import { useSelector, useDispatch } from "react-redux";
import { trackEventForAdoption } from "../adoption";
import {
  PAGE_VIEWED, TRACK_CONTENT_MAP_SCREEN_VIEW, TRACK_CONTENT_HUB_CONTENT_MAP_CLICKED_EVENT, TRACK_FILTER_CLUSTER_CREATED_EVENT,
  TRACK_FILTER_CLUSTER_SELECTED_EVENT, TRACK_FILTER_CLUSTER_UPDATED_EVENT, TRACK_FILTER_CLUSTER_DELETE_CLICKED_EVENT, TRACK_FILTER_CLUSTER_DELETED_EVENT,
  TRACK_BULK_ASSET_SELECTED_EVENT, TRACK_BULK_ASSET_EDITED_EVENT, TRACK_BULK_ASSET_DELETED_EVENT, TRACK_EXPORT_CLICKED_EVENT, TRACK_CONTENT_MAP_EXPORTED_EVENT,
  TRACK_CONTENT_HUB_EDIT_CONTENT_CLICKED_EVENT, TRACK_CONTENT_HUB_DELETE_CONTENT_CLICKED, TRACK_CONTENT_SEARCH_EVENT,
  TRACK_CONTENT_SECTION_CLICKED_EVENT,
  TRACK_CONTENT_FILTERED_EVENT
} from "src/constants/adoption/eventTypes";
import { CONTENT_MAP } from "src/constants/adoption/sourceTypes";
import {
  ClusterCreatedRequest, ClusterSelectedRequest, ClusterUpdatedRequest, ClusterDeleteClickedRequest, ClusterDeletedRequest, EditContentClicked, DeleteContentClicked,
  ContentSectionClicked, ContentFiltered, BulkAssetEditedRequest, BulkAssetsDeletedRequest
} from "src/types/adoption/contentMap";
import { Filter, PropertyEnum } from "src/types/contentMap";
import _ from "lodash";

export const useContentMapAdoption = () => {

  const dispatch = useDispatch();

  const contentMap = useSelector((state: any) => state.contentMap);

  // content map viewed
  const trackContentMapScreenView = () => {

    const event = {
      event: PAGE_VIEWED,
      properties: {
        screen_name: TRACK_CONTENT_MAP_SCREEN_VIEW
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // content map clicked
  const trackContentMapClicked = () => {

    const event = {
      event: TRACK_CONTENT_HUB_CONTENT_MAP_CLICKED_EVENT,
      properties: {

      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // filter cluster created
  const trackFilterClusterCreated = ({response}: ClusterCreatedRequest) => {

    const name = _.get(response, "name", "");
    const filters = _.get(response, "filters", []);
    const { isAssetFilter, isAssetTitleFilter, isStreamFilter, isFileTypeFilter, isTagFilter, isGroupFilter, isAssetStatusFilter } = getClusterDetails(filters || []);

    const event = {
      event: TRACK_FILTER_CLUSTER_CREATED_EVENT,
      properties: {
        filterClusterName: name,
        isAssetFilter: isAssetFilter,
        isAssetTitleFilter: isAssetTitleFilter,
        isStreamFilter: isStreamFilter,
        isFileTypeFilter: isFileTypeFilter,
        isTagFilter: isTagFilter,
        isGroupFilter: isGroupFilter,
        isAssetStatusFilter: isAssetStatusFilter
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // filter cluster selected
  const trackFilterClusterSelected = ({id}: ClusterSelectedRequest) => {

    const cluster = contentMap.cluster[id];
    const name = _.get(cluster, "item.name", "");
    const filters = _.get(cluster, "item.filters", []);
    const { isAssetFilter, isAssetTitleFilter, isStreamFilter, isFileTypeFilter, isTagFilter, isGroupFilter, isAssetStatusFilter } = getClusterDetails(filters);

    const event = {
      event: TRACK_FILTER_CLUSTER_SELECTED_EVENT,
      properties: {
        filterClusterName: name,
        isAssetFilter: isAssetFilter,
        isAssetTitleFilter: isAssetTitleFilter,
        isStreamFilter: isStreamFilter,
        isFileTypeFilter: isFileTypeFilter,
        isTagFilter: isTagFilter,
        isGroupFilter: isGroupFilter,
        isAssetStatusFilter: isAssetStatusFilter
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  //filter cluster updated
  const trackFilterClusterUpdated = ({ response }: ClusterUpdatedRequest) => {
    const name = _.get(response, "name", "");
    const filters = _.get(response, "filters", []);
    const { isAssetFilter, isAssetTitleFilter, isStreamFilter, isFileTypeFilter, isTagFilter, isGroupFilter, isAssetStatusFilter } = getClusterDetails(filters || []);

    const event = {
      event: TRACK_FILTER_CLUSTER_UPDATED_EVENT,
      properties: {
        filterClusterName: name,
        isAssetFilter: isAssetFilter,
        isAssetTitleFilter: isAssetTitleFilter,
        isStreamFilter: isStreamFilter,
        isFileTypeFilter: isFileTypeFilter,
        isTagFilter: isTagFilter,
        isGroupFilter: isGroupFilter,
        isAssetStatusFilter: isAssetStatusFilter
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // filter cluster delete clicked
  const trackFilterClusterDeleteClicked = ({ filterClusterName }: ClusterDeleteClickedRequest) => {

    const event = {
      event: TRACK_FILTER_CLUSTER_DELETE_CLICKED_EVENT,
      properties: {
        filterClusterName: filterClusterName,
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // filter cluster deleted
  const trackFilterClusterDeleted = ({ response }: ClusterDeletedRequest) => {

    const name = _.get(response, "name", "");
    const filters = _.get(response, "filters", []);
    const { isAssetFilter, isAssetTitleFilter, isStreamFilter, isFileTypeFilter, isTagFilter, isGroupFilter, isAssetStatusFilter } = getClusterDetails(filters);

    const event = {
      event: TRACK_FILTER_CLUSTER_DELETED_EVENT,
      properties: {
        filterClusterName: name,
        isAssetFilter: isAssetFilter,
        isAssetTitleFilter: isAssetTitleFilter,
        isStreamFilter: isStreamFilter,
        isFileTypeFilter: isFileTypeFilter,
        isTagFilter: isTagFilter,
        isGroupFilter: isGroupFilter,
        isAssetStatusFilter: isAssetStatusFilter
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // bulk asset selected
  const trackBulkAssetSelected = () => {

    const event = {
      event: TRACK_BULK_ASSET_SELECTED_EVENT,
      properties: {

      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // bulk asset edited
  const trackBulkAssetEdited = ({ sectionType }: BulkAssetEditedRequest) => {

    const event = {
      event: TRACK_BULK_ASSET_EDITED_EVENT,
      properties: {
        source_cta: CONTENT_MAP,
        content_section_type: sectionType
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // bulk asset deleted
  const trackBulkAssetsDeleted = ({ sectionType }: BulkAssetsDeletedRequest) => {

    const event = {
      event: TRACK_BULK_ASSET_DELETED_EVENT,
      properties: {
        source_cta: CONTENT_MAP,
        content_section_type: sectionType
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // export clicked
  const trackExportClicked = () => {

    const event = {
      event: TRACK_EXPORT_CLICKED_EVENT,
      properties: {

      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // content map exported
  const trackContentMapExported = () => {

    const event = {
      event: TRACK_CONTENT_MAP_EXPORTED_EVENT,
      properties: {

      }
    }

    dispatch(trackEventForAdoption(event));
  }

  const trackEditContentClicked = ({assetType, sectionType}: EditContentClicked) => {

    const event = {
      event: TRACK_CONTENT_HUB_EDIT_CONTENT_CLICKED_EVENT,
      properties: {
        source_cta: CONTENT_MAP,
        asset_type: _.upperCase(assetType),
        content_section_type: sectionType
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  const trackDeleteContentClicked = ({assetType, sectionType}: DeleteContentClicked) => {
    
    const event = {
      event: TRACK_CONTENT_HUB_DELETE_CONTENT_CLICKED,
      properties: {
        source_cta: CONTENT_MAP,
        asset_type:  _.upperCase(assetType),
        content_section_type: sectionType
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // content section clicked
  const trackContentSectionClicked = ({sectionType}: ContentSectionClicked) => {
    const event = {
      event: TRACK_CONTENT_SECTION_CLICKED_EVENT,
      properties: {
        source_cta: CONTENT_MAP,
        content_section_type: sectionType
      }
    }
    dispatch(trackEventForAdoption(event));
  }

  // content filtered
  const trackContentFiltered = ({sectionType, filterName}: ContentFiltered) => {
    const event = {
      event: TRACK_CONTENT_FILTERED_EVENT,
      properties: {
        content_section_type: sectionType,
        filter_name: _.lowerCase(filterName)
      }
    }
    dispatch(trackEventForAdoption(event));
  }

  const getClusterDetails = (filters: Filter[]) => {
    const isAssetFilter = _.some(filters, { property: { type: PropertyEnum.asset } });
    const isAssetTitleFilter = _.some(filters, { property: { type: PropertyEnum.title } });
    const isStreamFilter = _.some(filters, { property: { type: PropertyEnum.stream } });
    const isFileTypeFilter = _.some(filters, { property: { type: PropertyEnum.file_type } });
    const isTagFilter = _.some(filters, { property: { type: PropertyEnum.tags } });
    const isGroupFilter = _.some(filters, { property: { type: PropertyEnum.group } });
    const isAssetStatusFilter = _.some(filters, { property: { type: PropertyEnum.expiry_date } });

    return {
      isAssetFilter,
      isAssetTitleFilter,
      isStreamFilter,
      isFileTypeFilter,
      isTagFilter,
      isGroupFilter,
      isAssetStatusFilter
    }
  }

  const trackContentSearched = ({sourceCta, searchString, filter, searchTags, categories}) => {

    const event = {
      event: TRACK_CONTENT_SEARCH_EVENT,
      properties: {
        source_cta: sourceCta,
        search_string: searchString,
        filter: filter,
        search_tags: searchTags,
        categories: categories
      }
    }

    dispatch(trackEventForAdoption(event));
  }

    return {
      trackContentMapScreenView,
      trackContentMapClicked,
      trackFilterClusterCreated,
      trackFilterClusterSelected,
      trackFilterClusterUpdated,
      trackFilterClusterDeleteClicked,
      trackFilterClusterDeleted,
      trackBulkAssetSelected,
      trackBulkAssetEdited,
      trackBulkAssetsDeleted,
      trackExportClicked,
      trackContentMapExported,
      trackEditContentClicked,
      trackDeleteContentClicked,
      trackContentSearched,
      trackContentSectionClicked,
      trackContentFiltered
    }
  };